export { FaroRoutes } from './FaroRoutes';

export {
  createReactRouterV6Options,
  createReactRouterV6DataOptions,
  initializeReactRouterV6Instrumentation,
  initializeReactRouterV6DataRouterInstrumentation,
  createReactRouterV7DataOptions,
  createReactRouterV7Options,
} from './initialize';

export { setReactRouterV6SSRDependencies, setReactRouterV7SSRDependencies } from './routerDependencies';

export { withFaroRouterInstrumentation } from './withFaroRouterInstrumentation';

export type {
  ReactRouterV6CreateRoutesFromChildren,
  ReactRouterV6Dependencies,
  ReactRouterV6MatchRoutes,
  ReactRouterV6Params,
  ReactRouterV6RouteMatch,
  ReactRouterV6RouteObject,
  ReactRouterV6RoutesProps,
  ReactRouterV6RoutesShape,
  ReactRouterV6UseLocation,
  ReactRouterV6UseNavigationType,
  ReactRouterV6DataRouterDependencies,
} from './types';
